import React, { Component } from 'react';
import { Input, Form,Row, Col, Modal, Button,Select, message } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

const TextArea = Input.TextArea;
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 12 },
};
class CopRatingManagementModalDialog extends Component {

    refreshQuery() {
        const {
            userName,
            status
        } = this.props.ratingManagementQueryFields;
        this.props.loadRatingManagementInfo({userName, status})
    }

    componentDidUpdate() {
        const {
            copRatingManagementStatus,
        } = this.props;
        if(copRatingManagementStatus === ACTION_STATUS.SUCCESS) {
            message.success('CopAll Rating Management Info succeeded');
            this.props.initCopRatingManagementActionStatus();
            this.props.resetCopRatingManagementModal();
            this.refreshQuery();
        }
        if(copRatingManagementStatus === ACTION_STATUS.ERROR) {
            this.props.initCopRatingManagementActionStatus();
        }
    }


    onInputChange = ({name, value}) => {
        this.props.copRatingManagementChangeInput({name, value});
    }


    submitCopRatingManagement = () => {
        Modal.confirm({
            title: 'Are you sure copy access to select?',
            onOk: () => {
            
                const {
                    id,
                    employee,
                    comments,
                } = this.props.copRatingManagementModal.fields;
                this.props.copRatingManagement({id, employee, comments});
            },
            onCancel: () => {},
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            copRatingManagementModal,
            copRatingManagementStatus,
            instituteUserAccountOptions,
        } = this.props;
        const {
            isOpened,
            respErrMsg,
        } = copRatingManagementModal;

        const {
            comments,
            employee,
        } = copRatingManagementModal.fields

        const isSubmitLoading = copRatingManagementStatus === ACTION_STATUS.LOGINING;
        

        return (
            <div>
                <Modal
                    title={'Copy ALL Rating Management Info'}
                    centered
                    width={500}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetCopRatingManagementModal()}
                    footer={[
                        <Button key="back" onClick={() => this.props.resetCopRatingManagementModal()}>
                          Close
                        </Button>,
                        <Button key="save" type="primary" loading={isSubmitLoading} onClick={this.submitCopRatingManagement}>
                          Submit
                        </Button>,
                      ]}
                >
                <Row gutter={24}>
                    <Col span={12}>
                            <FormItem {...formItemLayout} label="Employee">
                            {getFieldDecorator('employee', {
                                initialValue: employee,
                                rules: [{
                                    required: true,
                                    message: 'Please select Employee',
                                }],
                                })(
                                <Select
                                        allowClear
                                        showSearch
                                        style={{ width: 200, marginLeft: 10 }}
                                        onChange={(val) => {
                                            this.onInputChange({ name: 'employee', value: val })
                                        }} 
                                        placeholder="Please select Employee">
                                    {instituteUserAccountOptions}
                                </Select>
                                )}
                            </FormItem>
                    </Col>
                </Row> 
                <Row gutter={24}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Comments">
                        {getFieldDecorator('comments', {
                            initialValue: comments,
                            rules: [{
                                required: false,
                                message: 'Please input Comments',
                            }],
                            })(
                            <TextArea 
                                style={{ width: 200, marginLeft: 10 }}
                                rows={3} 
                                onChange={(e) => {
                                    this.onInputChange({ name: 'comments', value: e.target.value })
                                }}
                            />
                            )}
                        </FormItem>
                    </Col>
                </Row> 



                    {
                    !!respErrMsg &&  
                    <Message negative>
                        <Message.Header>Response Error Message</Message.Header>
                        <p>{ respErrMsg }</p>
                    </Message>
                    }
                </Modal>
                
            </div>
            
        );
    }

}

const CopRatingManagementModalDialogForm = Form.create({ name: 'CopRatingManagementModalDialog' })(CopRatingManagementModalDialog);
export default CopRatingManagementModalDialogForm;
